import React from 'react';
import LegalDocument from '../../components/LegalDocument';

const Privacy = () => {
    return <LegalDocument type="privacy" />;
};

export default Privacy;
